(function () {
  'use strict';

  async function hasRequiredProduct() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart.items.some(item =>
      item.properties && item.properties._template === 'bdc'
    );
  }

  function validatePickupFields() {
    const dateInput = document.querySelector('input[name="attributes[配送日]"]');
    const timeInput = document.querySelector('input[name="attributes[配送時間]"]');

    const dateValue = dateInput ? dateInput.value.trim() : '';
    const timeValue = timeInput ? timeInput.value.trim() : '';

    return dateValue !== '' && timeValue !== '';
  }

  function createErrorMessage() {
    const el = document.createElement('p');
    el.id = 'pickup-date-error';
    el.style.cssText = 'color:#c0392b;font-size:13px;margin:8px 0;display:none;text-align:center;';
    el.textContent = '店頭受け取りの希望日・時間を選択してください。';
    return el;
  }

  async function init() {
    const checkoutBtn = document.querySelector('button[name="checkout"]');
    if (!checkoutBtn) return;

    const needsValidation = await hasRequiredProduct();
    if (!needsValidation) return;

    let errorMsg = document.getElementById('pickup-date-error');
    if (!errorMsg) {
      errorMsg = createErrorMessage();
      checkoutBtn.parentNode.insertBefore(errorMsg, checkoutBtn);
    }

    checkoutBtn.addEventListener('click', function (e) {
      if (!validatePickupFields()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        errorMsg.style.display = 'block';
        const dateArea = document.querySelector('.oddCalanderOffset');
        if (dateArea) {
          dateArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else {
        errorMsg.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();